import { Routes, Route, Navigate } from 'react-router-dom';
import { useEffect, useState } from 'react';
import Landscape from './Components/Landscape';
import './App.css';
import PageNotFound from './Components/PageNotFound';
import { getDesktopOrMobile } from './Utils/deviceDetails';
import QrCode from './Components/QrCode';
import StarInsurance from './Components/StarInsurance';
import DentalInsuranceForm from './Components/DentalInsurance';
import 'react-toastify/dist/ReactToastify.css';
import ReviewDashboard from "./Components/ReviewDentalInsurance"
import GroupInsurance from './Components/GroupInsurance';
import GroupInsuranceForm from './Components/GroupInsuranceForm';

const App = () => {

    const [isDesktop, setDeviceType] = useState(false)
    const [isLandscape, setLandscape] = useState(window.innerWidth > window.innerHeight)
    const handleOrientation = () => {
        detectDevice()
        setLandscape(window.innerWidth > window.innerHeight)
        document.documentElement.style.setProperty("--browser-offset", `calc(var(--vh, 1vh) * 100 - ${window.innerHeight}px)`);
    }

    const detectDevice = () => {
        const isDesktopWindows = getDesktopOrMobile()
        setDeviceType(isDesktopWindows)
    }

    useEffect(() => {
        window.addEventListener("resize", handleOrientation)
        handleOrientation()
        // window.open()
        return () => {
            window.removeEventListener("resize", handleOrientation)
        }
    }, [])


    return (
        <div className="App">
            {
                isDesktop ?
                    <Routes>
                        <Route path="/" element={<QrCode />} />
                        <Route path="/:dentalOfficeName" element={<QrCode />} />
                        <Route path="*" element={<QrCode />} />
                    </Routes> :
                    isLandscape ? <Landscape /> :
                        <Routes>
                            <Route exact path="/:company/:cameraside/*" element={<StarInsurance />} />
                            <Route exact path="review/:uid/:company/:cameraside/*" element={<ReviewDashboard />} />
                            <Route exact path="/group/:company/:cameraside/*" element={<GroupInsurance />} />
                            <Route path="*" element={<PageNotFound />} />
                            <Route path="/dental-form" element={<DentalInsuranceForm />} />
                            <Route path="/group/dental-form" element={<GroupInsuranceForm/>} />
                        </Routes>
            }
         
        </div >
    );
}

export default App;